export default { sha: '19c6bcdb27344ac94c16c2f4b9b68f462c377b50', buildNumber: 'undefined' }
